<template>
  <div>
    <template v-if="!item || !item.bottle_actions || item.bottle_actions.length === 0 || !item.bottle_actions[0]">
      -
    </template>
    <template v-else>
      <template v-if="item.bottle_actions[0].action === 'entered_storage'">
        Im Lager
      </template>
      <template v-else-if="item.bottle_actions[0].action === 'at_customer'">
        Beim Kunden
        <router-link v-if="item.bottle_actions[0]" :to="'/admin/customers/'+item.bottle_actions[0].customer_id"
                     class="text-primary">
          {{ item.bottle_actions[0].customer ? item.bottle_actions[0].customer.name : '' }}
        </router-link>
      </template>
      <template v-else-if="item.bottle_actions[0].action === 'from_customer'">
        Beim Fahrer
        <router-link class="text-primary" :to="['/admin','users',item.bottle_actions[0].driver_id].join('/')">{{
            findUserNameById(item.bottle_actions[0].driver_id)
          }}
        </router-link>
      </template>
      <template v-else-if="item.bottle_actions[0].action === 'back_in_storage'">
        Im Leergut
      </template>
      <template v-else-if="item.bottle_actions[0].action === 'left_storage'">
        Zurück beim GH
      </template>
    </template>

  </div>
</template>

<script>
export default {
  name: "BottleState",
  props: {
    item: Object,
    users: {type: Array, default: () => []}
  },
  methods: {
    findUserNameById(userId) {
      let user = this.users.find(el => el.id === userId);
      if (!user) {
        return 'unknown User'
      }
      return user.name || user.username
    }
  }
}
</script>

<style scoped>

</style>
